export const rowsToTuples = (rows) =>
    rows
        .filter((row) => row.filterType && row.operator)
        .map((row) => [row.filterType, row.operator, row.value]);

export const tuplesToRows = (tuples, keyPrefix = "row") =>
    (tuples ?? []).map(([filterType, operator, value], index) => ({
        id: `${keyPrefix}-${index}-${Date.now()}`,
        filterType,
        operator,
        value: String(value ?? ""),
    }));

export const serializeTuples = (tuples) => JSON.stringify(tuples ?? []);

export const isDirtyTuples = (baselineTuples, currentTuples) =>
    serializeTuples(baselineTuples) !== serializeTuples(currentTuples);

export const hasValidRows = (rows) =>
    rows.length > 0 &&
    rows.every(
        (row) =>
            row.filterType &&
            row.operator &&
            String(row.value ?? "").trim() !== "",
    );